export enum ServiceType {
  All = 'Tous',
  WebApp = 'Web application',
  Website = 'Website',
  Training = 'Formation',
  Consulting = 'Consultance',
  Branding = 'Branding',
  Design = 'Graphisme',
}
